import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthenticationStoreEffects } from './authentication-store.effects';
import { reducer } from './authentication-store.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('authentication', reducer),
    EffectsModule.forFeature([AuthenticationStoreEffects]),
  ],
  providers: [AuthenticationStoreEffects],
})
export class AuthenticationStoreModule {}
